import React from 'react';

export const userManagementConfig = [
  {
    path: '/user-management',
    component: React.lazy(() => import('./listing')),
  },
  {
    path: '/group-user-management/add',
    component: React.lazy(() => import('./add')),
  },
  {
    path: '/group-user-management/edit',
    component: React.lazy(() => import('./edit')),
  },
  {
    path: '/group-user-management/overview',
    component: React.lazy(() => import('./overview')),
  },
  {
    path: '/group-user-management/view',
    component: React.lazy(() => import('./view')),
  },
];
